import { render, staticRenderFns } from "./ShippoAddressRegion.vue?vue&type=template&id=4950d9b5&"
import script from "./ShippoAddressRegion.vue?vue&type=script&lang=ts&"
export * from "./ShippoAddressRegion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports